import { render, staticRenderFns } from "./InternInfoView.vue?vue&type=template&id=2a9df4d4&"
import script from "./InternInfoView.vue?vue&type=script&lang=js&"
export * from "./InternInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports